import * as React from "react";

import fetcher, { HTTPMethods } from "../hooks/fetcher";
import useIdentity from "../hooks/useIdentity";
import { getCookie, getParameter, logger } from "../util";

const destinationAfterTokenLogin = (pathname = "") => {
  const path = pathname.toLowerCase();

  if (path.startsWith("/dashboard/s/")) return pathname;
  if (path.startsWith("/emaillogin")) {
    return "/account-dashboard/orders/?EmailLogin=true";
  }
  return "/Account/ChangePassword";
};

const refreshSession = () =>
  fetcher("/api/auth/refresh", { method: HTTPMethods.POST }).catch((error) =>
    logger.error(error),
  );

const leaveTokenLogin = () => {
  if (!getParameter("ut")) return;

  window.location = destinationAfterTokenLogin(window.location?.pathname);
};

const UserAuth = () => {
  useIdentity();

  React.useEffect(() => {
    if (getCookie("ut")) {
      refreshSession().finally(leaveTokenLogin);
    }
  }, []);

  return null;
};

export default UserAuth;
